export default __webpack_public_path__ + "static/media/43.0358e5f5.jpg";